import SectionHead from "@/components/SectionHead";
import { Eye, PhoneCall, BadgeCheck } from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [Eye, BadgeCheck, PhoneCall];

const WebsiteBenefits = () => {
  const t = useLang().t;
  return (
  <section data-testid="website-benefits" className="bg-[#FDFBF7] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="website-benefits-head"
        eyebrow={t.benefits.eyebrow}
        title={t.benefits.title}
        sub={t.benefits.sub}
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-3">
        {t.benefits.cards.map((o, i) => {
          const Icon = ICONS[i];
          return (
          <div key={o.title} data-testid={`benefit-${i}`} className="card-site p-6 sm:p-8 text-center">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F5F2EB]">
              <Icon className="h-7 w-7 text-[#A88667]" />
            </div>
            <h3 className="mt-5 font-heading text-lg sm:text-xl font-bold text-[#3E2723]">{o.title}</h3>
            <p className="mt-2 text-sm sm:text-base leading-relaxed text-[#5D4037]">{o.desc}</p>
          </div>
          );
        })}
      </div>
    </div>
  </section>
  );
};

export default WebsiteBenefits;
